<template>
  <BForm
    class="formulario"
    @submit.prevent="podeGravar">
    <InputBasico
      ref="inputCodigo"
      type="text"
      name="nomeInput"
      label="Código*"
      class="input__codigo"
      v-model="form.codigo"
      v-validate="'required|min:3'"
      :errorsBag="errors"
      :upperCase="true" />

    <InputBasico
      type="text"
      name="nomeInput"
      label="Nome*"
      class="input__nome"
      v-model="form.nome"
      v-validate="'required|min:3'"
      :errorsBag="errors" />

    <InputBasico
      type="text"
      name="marcaInput"
      label="Marca*"
      class="input__marca"
      v-model="form.marca"
      v-validate="'required|min:3'"
      :errorsBag="errors" />

    <InputBasico
      type="text"
      name="fornecedorInput"
      label="Fornecedor"
      class="input__fornecedor"
      v-model="form.fornecedor" />

    <InputBasico
      type="text"
      name="codigobarraInput"
      label="Código de barras"
      class="input__codigobarra"
      v-model="form.codigobarra" />

    <InputMoeda
      name="precoInput"
      label="Preço*"
      class="input__preco"
      v-model="form.preco"
      v-validate="'required|min_value:0.00'"
      :errorsBag="errors" />

    <InputMoeda
      name="valorBarbeiroInput"
      label="Valor barbeiro por venda*"
      class="input__valorbarbeiro"
      v-model="form.valorbarbeiro"
      v-validate="'required|min_value:0.00'"
      :errorsBag="errors" />

    <div class="botao__container">
      <BButton
        type="submit"
        class="botao"
        variant="primary">
        Gravar
      </BButton>

      <BButton
        @click.prevent="sair"
        class="botao"
        variant="outline-primary">
        Sair
      </BButton>
    </div>
  </BForm>
</template>

<script>
import { BForm, BButton } from 'bootstrap-vue/es/components'
import FormularioCadastroMixin from '@/mixins/FormularioCadastroMixin'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputMoeda from '@/components/inputs/InputMoeda.vue'

export default {
  name: 'ProdutosCadastroForm',
  mixins: [FormularioCadastroMixin],
  components: {
    BForm,
    BButton,
    InputBasico,
    InputMoeda,
  },
  mounted() {
    this.$refs.inputCodigo.focar()
  },
  methods: {
    valoresIniciaisForm() {
      return {
        codigo: '',
        nome: '',
        marca: '',
        fornecedor: '',
        codigobarra: '',
        preco: 0,
        valorbarbeiro: 0,
      }
    },
    retornaCamposGravar() {
      return this.form
    },
    podeGravar() {
      if (this.form.valorbarbeiro <= this.form.preco) {
        this.gravar()
      } else {
        this.$awn.warning('O valor a receber do barbeiro deve ser menos que o preço do produto!')
      }
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.formulario {
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: $small-size) {
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 0.8em;
  }

  @media (min-width: $extra-large-size) {
    width: $medium-size;
  }
}

.input {
  &__codigo {
    @media (min-width: $small-size) {
      grid-column: 1 / 4;
    }
  }

  &__nome {
    @media (min-width: $small-size) {
      grid-column: 4 / -1;
    }
  }

  &__marca {
    @media (min-width: $small-size) {
      grid-column: 1 / 7;
    }
  }

  &__fornecedor {
    @media (min-width: $small-size) {
      grid-column: 7 / -1;
    }
  }

  &__codigobarra {
    @media (min-width: $small-size) {
      grid-column: 1 / 7;
    }
  }

  &__preco {
    @media (min-width: $small-size) {
      grid-column: 1 / 7;
    }

    @media (min-width: $medium-size) {
      grid-column: 1 / 5;
    }
  }

  &__valorbarbeiro {
    @media (min-width: $small-size) {
      grid-column: 7 / -1;
    }

    @media (min-width: $medium-size) {
      grid-column: 5 / 9;
    }
  }

}

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

</style>
